var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcoChatt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#3B0532",
    stroke: "#EDA817"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12L9 17.1962L9 6.80385L18 12Z",
    fill: "#EDA817"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcoChatt);
export default __webpack_public_path__ + "static/media/play-ico-chatt.421eab7ae7560e963e8aeee61969fc7e.svg";
export { ForwardRef as ReactComponent };